import React, { useEffect, useState } from 'react';

const parseNumber = (str) => parseFloat(str.replace(/[^0-9.]/g, ''));
const getSuffix = (str) => str.replace(/[0-9.]/g, '');

const StatCard = ({ stat, visible, delay }) => {
  const [count, setCount] = useState(0);

  const target = parseNumber(stat.number);
  const suffix = getSuffix(stat.number);

  useEffect(() => {
    if (!visible) return;
    const timeout = setTimeout(() => {
      const duration = 1800;
      const steps = 60;
      const increment = target / steps;
      let current = 0;
      const interval = setInterval(() => {
        current += increment;
        if (current >= target) {
          setCount(target);
          clearInterval(interval);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);
      return () => clearInterval(interval);
    }, delay);
    return () => clearTimeout(timeout);
  }, [visible, delay, target]); // ← added delay and target here

  return (
    <div
      className="stat-card"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(40px)',
        transition: `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms`,
      }}
    >
      <div className="stat-number">{count}{suffix}</div>
      <div className="stat-label">{stat.label}</div>
    </div>
  );
};

export default StatCard;
